export const TABS = {
  GENERAL_INFO: 0,
  ATTACHED_FILES: 1,
  FAMILY_INFO: 2,
  QUALIFICATIONS: 3,
  REWARDS: 4,
  SERVICES: 5,
  POSTINGS: 6,
  DISCIPLINE: 7,
  ACR: 8,
  APR: 9,
  DOSSIER: 10,
  LEAVE: 11,
  GPF: 12,
  INVENTORY: 13,
};

export const PROCUREMENT_TABS = {
  GENERAL_INFO: 0,
  SPEC_PREPARATION: 1,
  TENDER_NOTICE_PUBLICATION: 2,
  TENDER_OPENING: 3,
  TENDER_EVALUATION: 4,
  NOA: 5,
  AGREEMENT: 6,
  FINAL_RECEIVE: 7,
};
